import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"
import logo from "../../assets/logo.svg"

/* Globaler Header im neuen Landing-Page-Design: solide schwarz, volle
   Breite, Nav links, Login/Signup bzw. Profil rechts. Referrer-Tracking
   bleibt erhalten (wichtig fuer Affiliate/Attribution). */
export default function Header() {
  const { currentUser } = useAuth()

  useEffect(() => {
    if (!localStorage.getItem("referrer")) {
      const params = new URLSearchParams(window.location.search)
      const via = params.get("via")
      const ref = params.get("ref")
      const httpReferrer = document.referrer
      const keyword = params.get("q") || params.get("text") // Google, Bing, or Yandex search term
      if (via) {
        localStorage.setItem("referrer", via)
      } else if (ref) {
        localStorage.setItem("referrer", ref)
      } else if (httpReferrer) {
        const referrerUrl = new URL(httpReferrer)
        if (
          referrerUrl.hostname.includes("google") ||
          referrerUrl.hostname.includes("bing") ||
          referrerUrl.hostname.includes("yandex")
        ) {
          localStorage.setItem("referrer", referrerUrl.hostname.split(".")[1])
          if (keyword) {
            localStorage.setItem("search_keyword", keyword)
          }
        } else {
          localStorage.setItem("referrer", httpReferrer)
        }
      }
    }
  }, [])

  return (
    <header className="w-full h-16 bg-black border-b border-neutral-800 flex items-center justify-between px-4 md:px-10 sticky top-0 left-0 z-50">
      <div className="flex items-center gap-5 md:gap-9">
        <Link to="/" className="flex items-center">
          <img
            src={logo}
            alt="Clarity AI Logo"
            className="h-6 w-6 mr-2 shrink-0"
          />
          <span className="text-xl font-semibold text-white whitespace-nowrap">
            Clarity AI
          </span>
        </Link>
        <nav className="flex items-center gap-4 md:gap-7 text-sm font-medium text-gray-300">
          <Link
            to="/api"
            className="hover:text-white transition"
            aria-label="API Documentation"
          >
            API
          </Link>
          <Link
            to="/pricing"
            className="hover:text-white transition"
            aria-label="View pricing plans"
          >
            Pricing
          </Link>
          {currentUser && (
            <Link
              to="/dashboard"
              className="hover:text-white transition"
              aria-label="Dashboard"
            >
              Dashboard
            </Link>
          )}
        </nav>
      </div>
      <div className="flex items-center gap-3">
        {currentUser ? (
          <Link to="/profile" aria-label="Account settings">
            <div className="flex items-center justify-center w-9 h-9 rounded-full bg-neutral-800 hover:bg-neutral-700 transition-colors font-bold uppercase text-white">
              {(currentUser.email || "?").charAt(0)}
            </div>
          </Link>
        ) : (
          <>
            <Link
              to="/login"
              aria-label="Log in"
              className="text-sm font-medium text-gray-400 hover:text-white transition"
            >
              Log in
            </Link>
            <Link to="/register" aria-label="Sign up">
              <button className="h-9 px-4 rounded-lg font-bold text-black bg-white hover:bg-gray-200 transition text-sm">
                Sign up
              </button>
            </Link>
          </>
        )}
      </div>
    </header>
  )
}
